import {IS_BROWSER} from '../../constants/environment'
import {isOldBrowser} from '../../utils'
import {actionTypes, selectors} from '../actions/environment'
// Reducer

const initialState = {
  globalHeaderHeight: 0,
  inPageNavHeight: 0,
  footerHeight: 0,
  isBrowser: IS_BROWSER,
  window: {innerWidth: 0, innerHeight: 0, scrollY: 0},
  isOldBrowser: isOldBrowser(),
}

export default function location(state = initialState, {type, payload} = {}) {
  switch(type) {
    case actionTypes.UPDATE_GLOBAL_HEADER_HEIGHT:
      return {...state, globalHeaderHeight: payload.height}
    case actionTypes.UPDATE_FOOTER_HEIGHT:
      return {...state, footerHeight: payload.height}
    case actionTypes.UPDATE_IN_PAGE_NAV_HEIGHT:
      return {...state, inPageNavHeight: payload.height}
    case actionTypes.UPDATE_WINDOW_SIZE:
      return {
        ...state,
        window: {
          ...(state.window || {}),
          ...selectors.pickDimensions(payload),
        },
      }
    case actionTypes.UPDATE_WINDOW_SCROLL:
      return {
        ...state,
        window: {...(state.window || {}), ...selectors.pickScroll(payload)},
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/environment.js